import { render } from "./PreventivoPickup.vue?vue&type=template&id=8e4bf116&scoped=true"
import script from "./PreventivoPickup.vue?vue&type=script&lang=js"
export * from "./PreventivoPickup.vue?vue&type=script&lang=js"

import "./PreventivoPickup.vue?vue&type=style&index=0&id=8e4bf116&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4bf116"]])

export default __exports__